export default "__VITE_ASSET__DNtSG1cQ__"